module.exports = __webpack_public_path__ + "static/img/numbers_bg_local.fbb7c052.png";